<style scoped>

.configure-item {
    width: 250px
}

</style>

<template>

<el-card id="configure" class="box-card">
    <el-form ref="form" :model="form" label-width="250px">
        <el-row class="basic-margin">
            <el-col :span="20">
                <el-form-item label="是否开启视频：" prop="newPeopleReward" >
                  <el-switch
                    @change="save"
                    v-model="form.isShow"
                    active-text="开启"
                    inactive-text="关闭"
                    active-value="1"
                    inactive-value="0">
                    </el-switch>
                </el-form-item>

            </el-col>
        </el-row>
    </el-form>

</el-card>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'plus-configure',
  extends: BasicPager,
  data: function () {
    return {
      form: {
        isShow: 0
      }
    }
  },
  created: function () {
    this.loadList()
  },
  methods: {
    loadList: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.datas) {
            _this.form = dataInfo.datas
          }
        }
      }
      BasicModel.get(this, '/main/selectConfig.action', null, listener)
    },
    save: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              type: 'success',
              message: `修改成功！`
            })
            _this.loadList()
          }
        }
      }
      BasicModel.get(this, '/main/setConfig.action', { isShow: this.form.isShow }, listener)
    }
  }
}

</script>
